import mapTemplate from './map.component.html';
import {MapController as controller} from './map.controller';

const mapComponent = {
    templateUrl: mapTemplate.id,
    controller,
    controllerAs: 'Map',
    bindings: {
        options: '<'
    }
};

angular.module('BBPublicBooking').component('bbMap', mapComponent);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/map/map.component.js